import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { ArrowLeft, CalendarDays, FileImage, Globe2, Heart, Settings, Shirt, Users } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import { useSnapshot } from "valtio";

import { editorState } from "../../../utils/editor";
import { useEventPlannerPath } from "../../../hooks/useEventPlannerPath";
import { getCoupleDisplayName } from "../../../utils/couple.names";

const PlannerWeddingShell = () => {
  const { basePath } = useEventPlannerPath();
  const wedding = useSnapshot(editorState);
  const links = [
    { to: basePath, label: "Overview", icon: CalendarDays, end: true },
    { to: `${basePath}/guests`, label: "Guests", icon: Users },
    { to: `${basePath}/design`, label: "Designs", icon: FileImage },
    { to: `${basePath}/love-wall`, label: "Love Wall", icon: Heart },
    { to: `${basePath}/aso-ebi`, label: "Aso Ebi", icon: Shirt },
    { to: `${basePath}/website`, label: "Website", icon: Globe2 },
    { to: `${basePath}/settings/collaboration`, label: "Access", icon: Settings },
  ];
  const couple = getCoupleDisplayName(wedding) || "Client wedding";

  return (
    <Box w="full">
      <Box px={{ base: 4, md: 8 }} pb={4}>
        <Flex maxW="1380px" mx="auto" justify="space-between" align={{ base: "flex-start", md: "center" }} gap={4} flexDir={{ base: "column", md: "row" }}>
          <Box><Button as={NavLink} to="/planner/weddings" variant="link" leftIcon={<ArrowLeft size={16} />} color="#555B58" fontSize="13px">All weddings</Button><Text mt={2} fontSize="24px" fontWeight={600}>{couple}</Text><Text fontSize="13px" color="#737773">Client wedding workspace</Text></Box>
          <Flex gap={1} overflowX="auto" maxW="full" pb={1}>{links.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end}>{({ isActive }) => <Flex px={3} py={2} gap={2} align="center" whiteSpace="nowrap" borderRadius="9px" bg={isActive ? "black" : "white"} color={isActive ? "white" : "#343834"} border="1px solid #E2E2DD"><Icon size={15} /><Text fontSize="12px" fontWeight={600}>{label}</Text></Flex>}</NavLink>)}</Flex>
        </Flex>
      </Box>
      <Outlet />
    </Box>
  );
};

export default PlannerWeddingShell;
